import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";

/** Transient bottom-sheet payload; `qrCodeText` carries any HYUAR= prefix for the QR payload, `displayCode` is always the bare human-readable code. */
export interface CouponQRCodeDialogData {
  id: number;
  label: string;
  text: string;
  qrCodeUrl: string;
  qrCodeText: string;
  displayCode: string;
}

@Component({
  selector: "ya-couponqrcodedialog",
  templateUrl: "./couponqrcodedialog.component.html",
  styleUrls: ["./couponqrcodedialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class CouponQRCodeDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  public qrcodesvg: string = "";

  constructor(public bottomSheetRef: MatBottomSheetRef<CouponQRCodeDialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: CouponQRCodeDialogData) {
  }


  ngOnInit() {
    const me = this;
    if (me.data.qrCodeUrl) {
      // Strip the Hypersoft domain prefix so the QR encodes only the relevant query string.
      me.qrcodesvg = me.data.qrCodeUrl.replace("https://www.hypersoft.de/?", "");
    } else {
      // No URL available (e.g. single-redemption one-time code): generate QR from the text directly.
      me.qrcodesvg = me.data.qrCodeText || "";
    }
  }
  async ngAfterViewInit(): Promise<void> { }

  async ngOnDestroy(): Promise<void> { }

  public closeQRCodeModal() {
    this.bottomSheetRef.dismiss(this.data);
  }

}
